import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';

interface Props {
  size: number;
  color: string;
}

export default function SaveIcon({ size, color }: Props) {
  return (
    <FileDownloadDoneIcon sx={{ fontSize: size, color }} />
  )
}
